@if (showDuplicateWarning()) {
  <esignatur-tab-detection-warning></esignatur-tab-detection-warning>
} @else {
  <esignatur-header />
  <router-outlet />
}
<esignatur-snackbar />
